// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 205 ? "ed48eaa7" : chunkId) + "." + {"97":"0c5467b638eefdd9","132":"b37bfb0db614959b","205":"c41a6bc138c0991a"}[chunkId] + ".js";
};